import '../scss/app.scss';

const $ = jQuery;

let offset = 6;

$(document).ready(function() {
	// Initialize FitVids
	$('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]').parent().fitVids({ maxWidth: 1024 });

    $('a.modal-open').featherlight({
        targetAtr: 'href',
        persist: true,
    });
});

// Toggle
$('.js-toggle-trigger').bind('click', function(e) {
    e.preventDefault();
    jQuery(this).parent().find('.toggle-content').slideToggle('fast');
    jQuery(this).parent().toggleClass('is-expanded');
});

// Tabs
$(document).ready(function () {
	$('.accordion-tabs').each(function(index) {
		$(this).children('li').first().children('a').addClass('is-active').next().addClass('is-open').show();
	});
	$('.accordion-tabs').on('click', 'li > a.tab-link', function(event) {
		if (!$(this).hasClass('is-active')) {
			event.preventDefault();
			var accordionTabs = $(this).closest('.accordion-tabs');
			accordionTabs.find('.is-open').removeClass('is-open').hide();

			$(this).next().toggleClass('is-open').toggle();
			accordionTabs.find('.is-active').removeClass('is-active');
			$(this).addClass('is-active');
		} else {
			event.preventDefault();
		}
	});
});

// Sliding panel
$(document).ready(function() {
    $('.sliding-panel-button,.sliding-panel-fade-screen,.sliding-panel-close').on('click touchstart', function(e) {
        e.preventDefault();
        $('.sliding-panel-content,.sliding-panel-fade-screen').toggleClass('is-visible');
    });

    $('.sliding-panel-content li.menu-item-has-children > a').click(function(e) {
        e.preventDefault();
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).next('.sub-menu').removeClass('open');
        } else {
            $(this).addClass('open');
            $(this).next('.sub-menu').addClass('open');
        }
    });

    const fixSliderLoop = (slick, nextSlide) => {
        const cls = 'slick-current slick-active slick-center';
        if (nextSlide === 0) {
            setTimeout(function() {
                slick.$slider.find('[data-slick-index="' + slick.$slides.length + '"]').addClass(cls).siblings().removeClass(cls);
                for (let i = slick.options.slidesToShow - 1; i >= 0; i--) {
                    slick.$slider.find('[data-slick-index="' + i + '"]').addClass(cls);
                }
            }, 10);
        }
        if (nextSlide === slick.$slides.length - 1) {
            setTimeout(function() {
                slick.$slider.find('[data-slick-index="' + nextSlide + '"]').addClass(cls).siblings().removeClass(cls);
                for (let i = -1; i >= -1 * slick.options.slidesToShow; i--) {
                    slick.$slider.find('[data-slick-index="' + i + '"]').addClass(cls);
                }
            }, 10);
        }
    }

    const $featuredSlider = $('.featured-slider');
	$featuredSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear'
	});

    $featuredSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        fixSliderLoop(slick, nextSlide);
    });
});

/* grid */
var grid = document.querySelector('.grid');
var msnry;
if (grid) {
    msnry = new Masonry(grid, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
    });
    imagesLoaded(grid, function() {
        msnry.layout();
    });
}

$(document).ready(function() {
    $('a.load-more').click(function(e) {
        e.preventDefault();
        const button = $(this);
        button.html('Loading...');
        button.attr('disabled', true);
        button.blur();
        $.ajax({
            method: 'POST',
            url: ajax_object.ajax_url,
            data: {
                offset,
                action: 'sqa_load_jobs',
            },
        })
        .done(function(response) {
            if (response.data) {
                if (response.data.html) {
                    const htmlObject = $(response.data.html).hide();
                    $('.jobs-list').append(htmlObject);
                    htmlObject.slideDown();
                    $('body, html').animate({ scrollTop: $(htmlObject).offset().top - 50 });
                    fitBoxTitles('.jobs-item .job-header h3');
                }
                if (response.data.offset) {
                    offset = parseInt(response.data.offset);
                }
                if (response.data.count) {
                    if (response.data.count <= offset) {
                        button.hide();
                    }
                }
            }
        })
        .always(function() {
            button.html('Load more...');
            button.attr('disabled', false);
        });
    })
});

const fitBoxTitles = (selector, threeColumns = false) => {
    let maxHeight = 0;
    let columns = 1;
    if (window.innerWidth >= 1280 && threeColumns) {
        columns = 3;
    } else if (window.innerWidth >= 768) {
        columns = 2;
    }
    if (columns == 1) {
        return;
    }
    let column = 0;
    let row = 0;
    let rows = [];
    $(selector).each(function() {
        column += 1;
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
        if (column % columns === 0) {
            rows[row] = maxHeight;
            row += 1;
            maxHeight = 0;
        }
    });
    if (column % columns !== 0) {
        rows[row] = maxHeight;
    }
    column = 0;
    row = 0;
    $(selector).each(function() {
        const height = rows[row];
        $(this).height(height);
        column += 1;
        if (column % columns === 0) {
            row += 1;
        }
    });
};

$(document).ready(function() {
    if (window.innerWidth >= 768) {
        let maxHeight = 0;
        $('.section-latest-posts .single-post .post-content h3').each(function() {
            maxHeight = Math.max(maxHeight, $(this).height());
        });
        $('.section-latest-posts .single-post .post-content h3').each(function() {
            $(this).height(maxHeight);
        });
    }
});

$(document).ready(function() {
    $.mark = {
        jump: function (options) {
            var defaults = {
                selector: 'li.menu-item a'
            };
            if (typeof options == 'string') {
                defaults.selector = options;
            }

            options = $.extend(defaults, options);
            return $(options.selector).click(function (e) {
                var jumpobj = $(this);
                var target = jumpobj.attr('href');
                if (target == '#') {
                    e.preventDefault();
                    return;
                }
                if (target.indexOf('#') < 0) {
                    return;
                }
                var offset = $(target).offset().top - $('#wpadminbar').outerHeight() - $('.navigation').outerHeight() + 1;
                var thespeed = 1000;
                $('html,body').animate({
                    scrollTop: offset
                }, thespeed, 'swing');
                e.preventDefault();
            });
        }
    };
});

$(document).ready(function() {
    jQuery.mark.jump();
});

$('.share-social a').click(function(e) {
    e.preventDefault();
    const strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
    window.open($(this).attr('href'), "_blank", strWindowFeatures);
});

$('.toggle-see-more').click(function(e) {
    e.preventDefault();
    $(this).closest('div').find('li.hidden').removeClass('hidden');
    $(this).addClass('hidden');
});

$(document).ready(function() {
    if ($('.section-co2savings').length === 0) {
        return;
    }

    $('select[name="co2_saving_items"]').change(function() {
        $('.savings-co2-number .savings-number-inner span').html($('select[name="co2_saving_items"] option[value="' + $(this).val() + '"]').data('co2') + '%');
        $('.savings-plastic-number .savings-number-inner span').html($('select[name="co2_saving_items"] option[value="' + $(this).val() + '"]').data('plastic') + '%');
    });
});

$(document).ready(function() {
    $('.section-text.header-with-gif').append(`
        <a href="#" class="header-scroll"><i class="far fa-angle-double-down fa-4x"></i></a>
    `);

    $('a.header-scroll').click(function(e) {
        e.preventDefault();
        const target = $(this).parent().next('section');
        $('html,body').animate({
            scrollTop: $(target).offset().top,
        });
    });
});



// WEBPACK FOOTER //
// ./src/js/app.js